export const EMAIL_LESSONS_PT = [
  {
    id: 'email-1',
    numero: 1,
    titre: "Escrever um email claro",
    sousTitre: "A mensagem que obtém resposta",
    contexte: "Quer contactar a CAF, a CPAM ou uma administração por email. Como escrever uma mensagem clara que obtenha resposta rápida?",
    explication: [
      "**O assunto (Objet)**: uma frase clara e concisa que explica o pedido + número de processo. Exemplo: 'Pedido de comprovativo CAF — n.º 123456'.",
      "**A estrutura**: breve introdução (quem é, porquê escreve) + pedido claro + documentos anexados + cumprimentos.",
      "**Seja específico**: em vez de 'tenho um problema', escreva 'não recebi o pagamento de Dezembro, processo n.º 123456'.",
      "**Tamanho adequado**: 5 a 10 frases são suficientes. Mensagens muito longas são lidas com menos atenção. Seja conciso e respeitoso.",
      "**Inclua sempre**: número de processo, número de segurança social ou número fiscal, nome completo e data de nascimento.",
    ],
    question: "O que é mais importante incluir no assunto (Objet) do email para uma administração?",
    options: [
      { id: 'a', text: "A natureza do pedido + número de processo", correct: true },
      { id: 'b', text: "Apenas o nome completo", correct: false },
      { id: 'c', text: "A data do dia", correct: false },
    ],
    explication_reponse: "Um assunto claro ajuda o funcionário a compreender o pedido imediatamente e a encaminhá-lo para a pessoa certa. O número de processo é essencial para localizar o seu dossier rapidamente.",
  },
  {
    id: 'email-2',
    numero: 2,
    titre: "Anexar um ficheiro",
    sousTitre: "Sem erros",
    contexte: "Quer enviar documentos com o email. Passo a passo.",
    explication: [
      "**Ícone do clipe 📎**: presente em todos os programas de email. Clique nele para procurar o ficheiro no computador.",
      "**Confirmar o anexo**: após anexar, o nome do ficheiro aparece por baixo do email. Não envie antes de confirmar que aparece.",
      "**Tamanho máximo**: normalmente 5 a 10 megabytes. Para imagens grandes, comprima-as ou envie através do WeTransfer gratuitamente.",
      "**Formatos aceites**: PDF preferível para documentos oficiais. Imagens JPG são aceites mas PDF é mais profissional.",
      "**Nomear o ficheiro**: dê a cada ficheiro um nome claro antes de enviar — 'RIB_NomeApelido.pdf' é melhor que 'foto123.jpg'.",
    ],
    question: "Como confirmar que o ficheiro está realmente anexado antes de enviar?",
    options: [
      { id: 'a', text: "O nome do ficheiro aparece por baixo do email", correct: true },
      { id: 'b', text: "O ícone do clipe muda de cor", correct: false },
      { id: 'c', text: "Não é possível confirmar antes de enviar", correct: false },
    ],
    explication_reponse: "Após um anexo bem sucedido, o nome e o tamanho do ficheiro aparecem no email. Se não aparecerem, o ficheiro não foi anexado — tente novamente.",
  },
  {
    id: 'email-3',
    numero: 3,
    titre: "Reconhecer o email fraudulento",
    sousTitre: "Não clique antes de verificar",
    contexte: "Um email diz ser das Finanças ou da CAF e pede os seus dados. Como saber se é verdadeiro?",
    explication: [
      "**Verifique o endereço de email**: um email verdadeiro da CAF termina em @caf.fr ou @service-public.fr — não em @gmail.com ou @hotmail.com.",
      "**Sinais de fraude**: urgência exagerada ('responda em 24 horas'), pedido de senha ou dados bancários, link suspeito.",
      "**Não clique nos links directamente**: copie o endereço do site e escreva-o manualmente no navegador — ou vá directamente ao site oficial.",
      "**As administrações francesas nunca pedem** senhas nem números de cartão bancário por email.",
      "**Em caso de dúvida**: contacte directamente a entidade pelo número oficial para verificar. Não responda ao email suspeito.",
    ],
    question: "Um email diz ser da CAF e pede o número do seu cartão bancário. O que deve fazer?",
    options: [
      { id: 'a', text: "Não responder e denunciar em signal-spam.fr", correct: true },
      { id: 'b', text: "Dar as informações se o logótipo da CAF estiver presente", correct: false },
      { id: 'c', text: "Ligar para o número indicado no email", correct: false },
    ],
    explication_reponse: "A CAF nunca pede informações bancárias por email. É uma fraude. Denuncie em signal-spam.fr e não responda. Se duvidar da sua conta, contacte directamente a CAF pelo 3230.",
  },
  {
    id: 'email-4',
    numero: 4,
    titre: "Organizar a caixa de correio",
    sousTitre: "Para não perder um documento importante",
    contexte: "A caixa de correio está cheia e os documentos importantes perdem-se. Algumas soluções simples para organizar.",
    explication: [
      "**Pastas**: crie pastas com nomes como 'CAF', 'Impostos', 'Saúde', 'Habitação'. Mova cada email importante para a pasta correspondente.",
      "**A estrela ⭐**: no Gmail e Outlook, marque com estrela as mensagens importantes para as encontrar rapidamente mais tarde.",
      "**Cancelar subscrições**: clique em 'Cancelar subscrição' (Se désabonner) nas newsletters indesejadas.",
      "**Pesquisa**: use a função de pesquisa com o nome da entidade (por exemplo 'CAF') em vez de fazer scroll manual.",
      "**Arquivar**: as mensagens tratadas que não precisa imediatamente — arquive-as em vez de apagar. Ficam disponíveis para pesquisa.",
    ],
    question: "Como encontrar rapidamente um email antigo da CAF na caixa de correio?",
    options: [
      { id: 'a', text: "Usar a função de pesquisa com a palavra 'CAF'", correct: true },
      { id: 'b', text: "Fazer scroll manual por todas as mensagens", correct: false },
      { id: 'c', text: "Não é possível encontrá-lo se for antigo", correct: false },
    ],
    explication_reponse: "A função de pesquisa do email é muito poderosa — encontra qualquer mensagem em segundos com uma palavra. Use o nome da entidade ou o assunto do email.",
  },
];
